import type {
  ButtonHTMLAttributes,
  ComponentType,
  MouseEventHandler,
  ReactNode,
} from "react";

type IconButtonProps = Pick<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "onPointerEnter" | "onFocus" | "onTouchStart"
> & {
  icon: ComponentType<{ className?: string }> | ReactNode;
  iconName?: string;
  className?: string;
  dataName?: string;
  title?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export default function IconButton({
  icon,
  iconName,
  className,
  dataName,
  title,
  onClick,
  onPointerEnter,
  onFocus,
  onTouchStart,
}: IconButtonProps) {
  const classNames = [
    "button",
    "type-4",
    "hover",
    "icon-label",
    "tw:mr-auto tw:ml-auto tw:w-[55px]",
  ];

  if (className) {
    classNames.push(className);
  }

  const svgClassNames = [`icon-${iconName}-d`];

  // The icon is either a component (function) or an element.
  const IconComponent = icon;
  const iconElement =
    typeof IconComponent === "function" ? (
      <IconComponent className={svgClassNames.join(" ")} />
    ) : (
      IconComponent
    );

  return (
    <button
      type="button"
      className={classNames.join(" ")}
      data-name={dataName}
      onClick={onClick}
      onPointerEnter={onPointerEnter}
      onFocus={onFocus}
      onTouchStart={onTouchStart}
    >
      <div className="icon-wrapper centering tw:pt-[2px] tw:pb-[2px]">
        {iconElement}
      </div>
      <div className="label tw:text-center tw:text-[10px] tw:[font-family:sans-serif]">
        <span>{title}</span>
      </div>
    </button>
  );
}
